var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
// import { ILocalStorageService, ILocalStorageKey, LocalStorageService } from '../../services/localStorageService';
// import { ISharePointService, SharePointService } from '../../services/sharePointService';
import { LocalStorageService } from '@pm-tt/common-components/lib/LocalStorageService';
import { SharePointService } from '@pm-tt/common-components/lib/SharePointService';
// import { Locale, LanguageHelper } from '../../helpers/languageHelper';
// import { SnippetHelper }  from '../../helpers/snippetHelper';
import { LanguageHelper } from '@pm-tt/common-components/lib/LanguageHelper';
import { SnippetHelper } from '@pm-tt/common-components/lib/SnippetHelper';
import { UtilityNav } from '../utilityNav';
var Meganav = /** @class */ (function (_super) {
    __extends(Meganav, _super);
    function Meganav(props) {
        var _this = _super.call(this, props) || this;
        // private openMegaDropdownRef: HTMLElement; // desktop open dropdown ref
        _this._isMounted = false;
        // not using autobind! we don't write a function but add a variable
        _this.megaHandleClick = function (event) {
            // console.log("we clicked");
            if (!_this.props.isTablet) {
                var myElement = _this.parentRef;
                var megadropdownElement = _this.megadropdownRef;
                // console.log("myElement:");
                // console.log(myElement);
                if (megadropdownElement) {
                    if (myElement.contains(event.target) || megadropdownElement.contains(event.target)) {
                        // console.log("clicked inside");
                        // the click is inside so continue to whatever we were doing before
                        return;
                    }
                }
                else {
                    if (myElement.contains(event.target)) {
                        // console.log("clicked inside");
                        // the click is inside so continue to whatever we were doing before
                        return;
                    }
                }
                if (_this.state.meganavDropdownOpen) {
                    // the click is outside, do something
                    // console.log("clicked outside");
                    // this.props.clickOutsideCallback(event);
                    document.getElementById("s4-workspace").classList.toggle("noScroll");
                    document.getElementById("mainHeader").classList.toggle("meganavOpen");
                    _this.setState({
                        meganavDropdownOpen: false,
                        meganavOpenItem: null,
                        meganavOpenItemIndex: null,
                        meganavCategoryOpen: false,
                        meganavCategoryOpenItem: null,
                        meganavCategoryOpenItemIndex: null
                    });
                }
            }
        };
        _this.openMeganav = function (itemId, toplevelIndex, event) {
            // in desktop, this opens the meganav dropdown for the selected top-level item.
            // in mobile, this slides the nav to the second-level menu for the selected top-level item.
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            return function () {
                // console.log("openMeganav -- itemID: " + itemId + " this.state.meganavOpenItem: " + this.state.meganavOpenItem);
                if (_this.state.meganavOpenItem == itemId) { // clicked the same link to close it (for mobile - we call this function again on the "back" button and pass in the same ID)
                    document.getElementById("s4-workspace").classList.toggle("noScroll");
                    document.getElementById("mainHeader").classList.toggle("meganavOpen");
                    if (_this.props.isTablet) { // should this be a callback function? I think I had this as a callback before but it didn't work
                        _this.slidePanel("right"); // animation to slide to the right
                        _this.props.tabIndexCallback(1, false, null);
                    }
                    _this.setState({
                        meganavDropdownOpen: false,
                        meganavOpenItem: null,
                        meganavOpenItemIndex: null,
                        meganavCategoryOpen: false,
                        meganavCategoryOpenItem: null,
                        meganavCategoryOpenItemIndex: null
                    });
                }
                else { // this.slidePanel("reset")
                    if (!_this.state.meganavDropdownOpen) {
                        document.getElementById("s4-workspace").classList.toggle("noScroll");
                        document.getElementById("mainHeader").classList.toggle("meganavOpen");
                    }
                    var firstCategoryHasChildren = false;
                    console.log(_this.state.meganavItems);
                    if (_this.state.meganavItems[toplevelIndex].Items && _this.state.meganavItems[toplevelIndex].Items[0].Items) {
                        firstCategoryHasChildren = true;
                    }
                    _this.setState({
                        meganavDropdownOpen: true,
                        meganavOpenItem: itemId,
                        meganavOpenItemIndex: toplevelIndex,
                        // meganavCategoryOpen: this.props.isTablet ? false : true,
                        // meganavCategoryOpenItem: this.props.isTablet ? null : 1,
                        //meganavCategoryOpenItemIndex: this.props.isTablet ? null : 0
                        meganavCategoryOpen: !_this.props.isTablet && firstCategoryHasChildren ? true : false,
                        meganavCategoryOpenItem: !_this.props.isTablet && firstCategoryHasChildren ? 1 : null,
                        meganavCategoryOpenItemIndex: !_this.props.isTablet && firstCategoryHasChildren ? 0 : null
                    }, function () {
                        if (_this.props.isTablet) {
                            _this.slidePanel("left"); // animation to slide to the left
                            _this.props.tabIndexCallback(1, true, null);
                        }
                        else {
                            // if meganav, change focus to be inside meganav
                            if (document.getElementById("megamenuDropdown")) {
                                // let firstFocusElement = document.querySelectorAll("#megamenuDropdown A, #megamenuDropdown BUTTON")[0] as HTMLElement;
                                // firstFocusElement.focus();
                                document.getElementById("megamenuDropdown").focus();
                            }
                        }
                    });
                }
            };
        };
        _this.openMeganavCategory = function (itemId, secondlevelIndex, event) {
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            // very similar to openMeganav, but we needed to have something specific to the second-level category nav to be able to open the third-level nav.
            // this sets the states for meganavCategoryOpen: boolean and meganavCategoryOpenItem: number 
            return function () {
                if (_this.state.meganavCategoryOpenItem == itemId) { // clicked the same link to close it
                    if (_this.props.isTablet) { // probably redundant, since this only happens in mobile
                        _this.slidePanel("right");
                        _this.props.tabIndexCallback(2, false, null);
                        _this.setState({
                            meganavCategoryOpen: false,
                            meganavCategoryOpenItem: null,
                            meganavCategoryOpenItemIndex: null
                        });
                    }
                    else {
                        // could not figure out how to force nothing to happen
                        _this.setState({
                            meganavCategoryOpen: true,
                            meganavCategoryOpenItem: itemId,
                            meganavCategoryOpenItemIndex: secondlevelIndex
                        });
                    }
                }
                else {
                    _this.setState({
                        meganavCategoryOpen: true,
                        meganavCategoryOpenItem: itemId,
                        meganavCategoryOpenItemIndex: secondlevelIndex
                    }, function () {
                        if (_this.props.isTablet) { // probably redundant, since this only happens in mobile
                            _this.slidePanel("left");
                            _this.props.tabIndexCallback(2, true, null);
                        }
                        else {
                            // change focus to be inside the subcontainer
                            var firstFocusElement = document.querySelectorAll("#megamenuDropdown .megamenuRight")[0];
                            firstFocusElement.focus();
                        }
                    });
                }
            };
        };
        _this.slidePanel = function (dir) {
            // sets the style="left: xx" position on the #mobileNav container element to push it to the right or left (or reset to zero).
            // console.log("direction slide:" + dir);
            var panel = document.getElementById("mobileNavContainer");
            var panelWidth = this.props.componentWidth;
            var newPosition = 0;
            var currentPosition = panel.style.left.length ? panel.style.left : "0";
            // console.log("currentPosition: " + currentPosition);
            if (dir == "left") {
                newPosition = parseInt(currentPosition) - panelWidth;
            }
            else if (dir == "right") {
                newPosition = parseInt(currentPosition) + panelWidth;
            }
            else { // reset
                newPosition = 0;
            }
            // console.log("newPosition: " + newPosition);
            panel.style.left = newPosition + "px";
        };
        _this.state = {
            meganavItems: [],
            meganavDropdownOpen: false,
            meganavOpenItem: null,
            meganavOpenItemIndex: null,
            meganavCategoryOpen: false,
            meganavCategoryOpenItem: null,
            meganavCategoryOpenItemIndex: null,
            currentLang: "",
            viewAllSnippet: null,
            backSnippet: null
        };
        return _this;
    }
    Meganav.prototype.componentDidMount = function () {
        var _this = this;
        this._isMounted = true;
        SnippetHelper.getSnippet("#viewAll").then(function (snippet) {
            // set snippet to state
            if (snippet.length > 0 && _this._isMounted) {
                _this.setState({
                    viewAllSnippet: snippet[0].snippet
                });
            }
        });
        SnippetHelper.getSnippet("#back").then(function (snippet) {
            // set snippet to state
            if (snippet.length > 0 && _this._isMounted) {
                _this.setState({
                    backSnippet: snippet[0].snippet
                });
            }
        });
        SnippetHelper.getSnippet("#serviceLink").then(function (snippet) {
            // set snippet to state
            if (snippet.length > 0 && _this._isMounted) {
                _this.setState({
                    serviceLinkSnippet: snippet[0].url.description,
                    serviceLinkUrl: snippet[0].url.url,
                    serviceLinkNewWindow: snippet[0].openNew
                });
            }
        });
        var currentLocale = LanguageHelper.getCurrentLocale();
        this.setState({
            currentLang: currentLocale.Language
        }, function () {
            // load data
            _this.loadData();
        });
        document.addEventListener('click', this.megaHandleClick, false);
    };
    Meganav.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.megaHandleClick, false);
        this._isMounted = false;
        // double-check to make sure things are cleaned up
        if (document.getElementById("mainHeader").classList.contains("meganavOpen")) {
            document.getElementById("mainHeader").classList.remove("meganavOpen");
        }
    };
    Meganav.prototype.componentDidUpdate = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.log("property changed");
                // console.log(nextProps);
                if (nextProps.sliderFirstHidden != this.props.sliderFirstHidden) {
                    // console.log("sliderFirstHidden has changed");
                }
                if (nextProps.sliderSecondHidden != this.props.sliderSecondHidden) {
                    // console.log("sliderSecondHidden has changed");
                }
                return [2 /*return*/];
            });
        });
    };
    Meganav.prototype.render = function () {
        var _this = this;
        var meganavDesktop = null;
        var meganavThirdlevel = null;
        if (this.props.isTablet) {
            // if mobile nav, we have to set the width of the mobile nav dropdown
            this.topPanelStyle = {
                width: this.props.componentWidth + 'px'
            };
            this.secondPanelStyle = {
                width: this.props.componentWidth + 'px',
                height: this.props.componentHeight + 'px',
                left: this.props.componentWidth + 'px'
            };
        }
        else {
            this.topPanelStyle = {
                maxHeight: this.props.componentHeight + 'px',
            };
            this.secondPanelStyle = {
                maxHeight: this.props.componentHeight + 'px',
            };
            // console.log(this.topPanelStyle);
            if (this.state.meganavItems.length > 0 && this.state.meganavOpenItem) {
                if (this.state.meganavItems[this.state.meganavOpenItemIndex].IsMega) {
                    // this section sets a variable for the third level nav columns
                    var maxItems = 12; // max number of links per column
                    if (this.state.meganavCategoryOpenItem > 0) {
                        if (this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Items.length > maxItems) {
                            // we need two columns
                            var col1 = this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Items.slice(0, maxItems);
                            var col2 = this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Items.slice(maxItems);
                            meganavThirdlevel = React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "col-md-4" },
                                    React.createElement("ul", null, col1.map(function (thirdlevel, thirdIndex, arr) {
                                        return React.createElement("li", { key: "tt3a" + thirdIndex },
                                            React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(3, thirdIndex == 0 ? 0 : -100, arr, e); }, href: thirdlevel.Url, target: thirdlevel.IsNewTab ? "_blank" : "_self", className: thirdlevel.IsExternal ? "external" : "" }, thirdlevel.Title));
                                    }))),
                                React.createElement("div", { className: "col-md-4" },
                                    React.createElement("ul", null, col2.map(function (thirdlevel, thirdIndex, arr) {
                                        return React.createElement("li", { key: "tt3b" + thirdIndex },
                                            React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(3, _this.state.meganavItems[_this.state.meganavOpenItemIndex].Items[_this.state.meganavCategoryOpenItemIndex].Url ? -100 : thirdIndex, arr, e); }, href: thirdlevel.Url, target: thirdlevel.IsNewTab ? "_blank" : "_self", className: thirdlevel.IsExternal ? "external" : "" }, thirdlevel.Title));
                                    }))));
                        }
                        else {
                            // we just need one column of links
                            meganavThirdlevel =
                                React.createElement("div", { className: "col-md-4" },
                                    React.createElement("ul", null, this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Items.map(function (thirdlevel, thirdIndex, arr) {
                                        return React.createElement("li", { key: "tt3" + thirdIndex },
                                            React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(3, thirdIndex == arr.length - 1 && _this.state.meganavItems[_this.state.meganavOpenItemIndex].Items[_this.state.meganavCategoryOpenItemIndex].Url ? -100 : thirdIndex, arr, e); }, href: thirdlevel.Url, target: thirdlevel.IsNewTab ? "_blank" : "_self", className: thirdlevel.IsExternal ? "external" : "" }, thirdlevel.Title));
                                    })));
                        }
                    }
                    meganavDesktop = React.createElement("div", { id: "megamenuDropdown", style: this.topPanelStyle, tabIndex: 0, ref: function (el) { return _this.megadropdownRef = el; } },
                        React.createElement("div", { className: "megamenuLeft" },
                            React.createElement("h2", null, this.state.meganavItems[this.state.meganavOpenItemIndex].Url ? (React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(2, -1, null, e); }, href: this.state.meganavItems[this.state.meganavOpenItemIndex].Url, target: this.state.meganavItems[this.state.meganavOpenItemIndex].IsNewTab ? "_blank" : "_self" }, this.state.meganavItems[this.state.meganavOpenItemIndex].Title)) : (React.createElement(React.Fragment, null, this.state.meganavItems[this.state.meganavOpenItemIndex].Title))),
                            React.createElement("ul", null, this.state.meganavItems[this.state.meganavOpenItemIndex].Items.map(function (secondlevel, secondlevelIndex, arr) {
                                return React.createElement("li", { key: "tt2" + secondlevel.Order }, secondlevel.Items ? (React.createElement("button", { onKeyDown: function (e) { return _this.processKeyPress(2, secondlevelIndex == 0 && _this.state.meganavItems[_this.state.meganavOpenItemIndex].Url ? -100 : secondlevelIndex, arr, e); }, className: secondlevel.Order == _this.state.meganavCategoryOpenItem ? "selected" : "", onClick: _this.openMeganavCategory(secondlevel.Order, secondlevelIndex, event) }, secondlevel.Title)) : (React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(2, secondlevelIndex == 0 && _this.state.meganavItems[_this.state.meganavOpenItemIndex].Url ? -100 : secondlevelIndex, arr, e); }, href: secondlevel.Url, target: secondlevel.IsNewTab ? "_blank" : "_self" }, secondlevel.Title)));
                            }))),
                        React.createElement("div", { className: "megamenuRight", tabIndex: 0 }, this.state.meganavDropdownOpen && this.state.meganavCategoryOpen && this.state.meganavCategoryOpenItem && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-4" },
                                    React.createElement("h3", null, this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Title),
                                    this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Image && (React.createElement("p", null,
                                        React.createElement("img", { src: this.processImageUrl(this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Image), alt: this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].ImageAlt }))),
                                    this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Description && (React.createElement("p", null, this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Description))),
                                meganavThirdlevel),
                            this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Url && (React.createElement("div", { className: "row", id: "meganavViewAll" },
                                React.createElement("div", { className: "col-md-4 col-md-push-8" },
                                    React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(3, -2, null, e); }, target: this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].IsNewTab ? "_blank" : "_self", href: this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Url, className: this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].IsExternal ? "external" : "" },
                                        this.state.viewAllSnippet,
                                        " ",
                                        this.state.meganavItems[this.state.meganavOpenItemIndex].Items[this.state.meganavCategoryOpenItemIndex].Title))))))));
                }
            }
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { id: "meganav", ref: function (el) { return _this.parentRef = el; }, style: this.topPanelStyle },
                this.state.meganavItems.map(function (toplevel, toplevelIndex) {
                    return React.createElement("li", { key: "tt1" + toplevel.Order },
                        toplevel.Items ? (React.createElement("button", { tabIndex: _this.props.sliderFirstHidden ? -1 : 0, className: toplevel.Order == _this.state.meganavOpenItem ? "hasChildren selected" : "hasChildren", onClick: _this.openMeganav(toplevel.Order, toplevelIndex, event) }, toplevel.Title)) : (React.createElement("a", { tabIndex: _this.props.sliderFirstHidden ? -1 : 0, href: toplevel.Url, target: toplevel.IsNewTab ? "_blank" : "_self" }, toplevel.Title)),
                        toplevel.Items && _this.state.meganavDropdownOpen && _this.state.meganavOpenItem == toplevel.Order && (React.createElement(React.Fragment, null, (_this.props.isTablet || !toplevel.IsMega) && (React.createElement("ul", { style: _this.secondPanelStyle },
                            _this.props.isTablet ? (React.createElement(React.Fragment, null,
                                React.createElement("li", null,
                                    React.createElement("button", { onKeyDown: function (e) { return _this.processKeyPress(1, -1, null, e); }, ref: function (el) { return _this.backButtonRef1 = el; }, tabIndex: _this.props.sliderSecondHidden ? -1 : 0, className: "dropdownBack", onClick: _this.openMeganav(toplevel.Order, toplevelIndex, event) }, _this.state.backSnippet)),
                                React.createElement("li", null,
                                    React.createElement("h3", null, toplevel.Url ? (React.createElement("a", { tabIndex: _this.props.sliderSecondHidden ? -1 : 0, href: toplevel.Url, target: toplevel.IsNewTab ? "_blank" : "_self" }, toplevel.Title)) : (React.createElement("span", null, toplevel.Title)))))) : (React.createElement(React.Fragment, null, toplevel.Url && (React.createElement("li", null,
                                React.createElement("a", { href: toplevel.Url, onKeyDown: function (e) { return _this.processKeyPress(2, -1, null, e); }, target: toplevel.IsNewTab ? "_blank" : "_self" }, toplevel.Title))))),
                            toplevel.Items.map(function (secondlevel, secondlevelIndex, arr) {
                                return React.createElement("li", { key: "tt2" + secondlevel.Order },
                                    secondlevel.Items ? (React.createElement("button", { tabIndex: _this.props.sliderSecondHidden ? -1 : 0, onKeyDown: function (e) { return _this.processKeyPress(2, secondlevelIndex, arr, e); }, onClick: _this.openMeganavCategory(secondlevel.Order, secondlevelIndex, event) }, secondlevel.Title)) : (React.createElement("a", { href: secondlevel.Url, tabIndex: _this.props.sliderSecondHidden ? -1 : 0, onKeyDown: function (e) { return _this.processKeyPress(2, secondlevelIndex == 0 && toplevel.Url ? "-100" : secondlevelIndex, arr, e); }, target: secondlevel.IsNewTab ? "_blank" : "_self", className: secondlevel.IsExternal ? "external" : "" }, secondlevel.Title)),
                                    secondlevel.Items && _this.state.meganavDropdownOpen && _this.state.meganavCategoryOpen && _this.state.meganavCategoryOpenItem == secondlevel.Order && (React.createElement("ul", { style: _this.secondPanelStyle },
                                        _this.props.isTablet && (React.createElement(React.Fragment, null,
                                            React.createElement("li", null,
                                                React.createElement("button", { onKeyDown: function (e) { return _this.processKeyPress(2, -1, null, e); }, ref: function (el) { return _this.backButtonRef2 = el; }, className: "dropdownBack", onClick: _this.openMeganavCategory(secondlevel.Order, secondlevelIndex, event) }, "Back")),
                                            React.createElement("li", null,
                                                React.createElement("h3", null, secondlevel.Url ? (React.createElement("a", { href: secondlevel.Url, target: secondlevel.IsNewTab ? "_blank" : "_self", className: secondlevel.IsExternal ? "external" : "" }, secondlevel.Title)) : (React.createElement("span", null, secondlevel.Title)))))),
                                        secondlevel.Items.map(function (thirdlevel, thirdlevelIndex, arr) {
                                            return React.createElement("li", { key: thirdlevelIndex },
                                                React.createElement("a", { onKeyDown: function (e) { return _this.processKeyPress(3, thirdlevelIndex, arr, e); }, href: thirdlevel.Url, target: thirdlevel.IsNewTab ? "_blank" : "_self", className: thirdlevel.IsExternal ? "external" : "" }, thirdlevel.Title));
                                        }))));
                            }))))));
                }),
                this.state.serviceLinkSnippet && this.state.serviceLinkUrl && (React.createElement("li", { id: "serviceLink" },
                    React.createElement("a", { href: this.state.serviceLinkUrl, target: this.state.serviceLinkNewWindow ? "_blank" : "_self" }, this.state.serviceLinkSnippet)))),
            this.props.isTablet && (React.createElement("div", { id: "utilityNavContainer" },
                React.createElement(UtilityNav, { isTablet: this.props.isTablet, componentWidth: this.props.componentWidth, componentHeight: this.props.componentHeight, tabIndexCallback: function (level, hide, element) { return _this.props.tabIndexCallback(level, hide, element); } }))),
            !this.props.isTablet && this.state.meganavItems.length > 0 && this.state.meganavOpenItem && this.state.meganavItems[this.state.meganavOpenItemIndex].IsMega && meganavDesktop));
    };
    Meganav.prototype.processImageUrl = function (url) {
        return url.substring(url.indexOf(url.split('/')[3]) - 1);
    };
    // @level: 1 and 2 affect the backbutton refs in mobile / 3 is used in desktop
    // @i: >0 the map index / -1: back button / -2: "view all" link / -100: ignore it (either there is a "view all" link so this last link can be ignored, or this is the first link but has a parent header link ahead of it)
    // @arr: passes in the map array, but if the back button, set it to null
    Meganav.prototype.processKeyPress = function (level, i, arr, e) {
        // console.log("inside processKeypress");
        var closeLevel2 = false;
        var closeLevel3 = false;
        // if back button (mobile)
        if (i === -1 && e.keyCode == 9 && e.shiftKey) {
            if (this.props.isTablet) {
                // we want to go back to the search button if in mobile
                // console.log("backwards");
                document.getElementById("toggleSearch").focus();
                e.preventDefault();
            }
            else {
                // we want to go back to the selected parent and close the dropdown in desktop
                closeLevel2 = true;
            }
        }
        // if "view all" link (desktop), we want it to go back to the parent button and close the subcategory
        if (i === -2 && level == 3 && !this.props.isTablet) {
            if (e.keyCode == 9 && !e.shiftKey) {
                closeLevel3 = true;
            }
        }
        if (arr) {
            // if first item 
            if (i === 0) {
                if (e.keyCode == 9 && e.shiftKey) {
                    // console.log("this is the first item")
                    if (level == 3) { // this is the last level of links
                        // in a meganav, we want to backwards-tab and close the category dropdown and return to the praent element
                        if (document.getElementById("megamenuDropdown")) {
                            closeLevel3 = true;
                        }
                    }
                    else if (level == 2) {
                        if (!this.props.isTablet) {
                            // for the second level (desktop), we want to backwards-tab and close the dropdown
                            closeLevel2 = true;
                        }
                    }
                }
            }
            // if last item
            if (i === arr.length - 1) {
                if (e.keyCode == 9 && !e.shiftKey) {
                    if (this.props.isTablet) {
                        // we want to return to the top of the #langdropdown element in mobile
                        if (level == 2) {
                            this.backButtonRef1.focus();
                        }
                        else if (level == 3) {
                            this.backButtonRef2.focus();
                        }
                        e.preventDefault();
                    }
                    else {
                        if (level === 2) {
                            //console.log("level = 2");
                            // if this is the last item in the desktop meganavLeft, then we want to close the whole meganav and return focus to the parent button
                            closeLevel2 = true;
                        }
                        else if (level === 3) {
                            // if this is the last item in the desktop meganavRight, then we want to close it and return focus to the parent button
                            closeLevel3 = true;
                        }
                    }
                }
            }
        }
        // now do the stuff
        if (closeLevel2) {
            var parentItem = document.querySelectorAll("#meganav .selected")[0];
            parentItem.focus();
            e.preventDefault();
            // close the whole meganav
            this.setState({
                meganavDropdownOpen: false,
                meganavOpenItem: null,
                meganavOpenItemIndex: null,
                meganavCategoryOpen: false,
                meganavCategoryOpenItem: null,
                meganavCategoryOpenItemIndex: null
            });
            document.getElementById("mainHeader").classList.remove("meganavOpen");
            return;
        }
        if (closeLevel3) {
            var parentItem = document.querySelectorAll(".megamenuLeft .selected")[0];
            e.preventDefault();
            parentItem.focus();
            // close the open category
            this.setState({
                meganavCategoryOpen: false,
                meganavCategoryOpenItem: null,
                meganavCategoryOpenItemIndex: null
            });
            return;
        }
    };
    Meganav.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonData, meganavData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        jsonData = _a.sent();
                        if (jsonData) {
                            meganavData = JSON.parse(jsonData).Items;
                            if (this._isMounted) {
                                this.setState({
                                    meganavItems: meganavData
                                });
                            }
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log("error");
                        console.log(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Meganav.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var p;
            var _this = this;
            return __generator(this, function (_a) {
                p = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var localStorageService, jsonData, localizedKeyName, localStorageKeyValue, err_2, sharePointService, spContext, spResponse, err_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                localStorageService = new LocalStorageService();
                                localizedKeyName = "TD-" + this.state.currentLang;
                                localStorageKeyValue = {
                                    keyName: "td",
                                    keyPrefix: localizedKeyName,
                                    timeOutInMinutes: 240 //this.localAdStorageTimeout
                                };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, localStorageService.get(localStorageKeyValue)];
                            case 2:
                                // console.log("inside try");
                                //try and get cached results from local storage
                                jsonData = _a.sent();
                                // console.log("cached results?")
                                // console.log(jsonData);
                                if (jsonData) {
                                    // //appear to have valid cached results, resolve these
                                    // console.log("cached results");
                                    // console.log(jsonData);
                                    resolve(jsonData);
                                    return [2 /*return*/]; // end the promise
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                err_2 = _a.sent();
                                //we are going to ignore error; after failing, we continue down to the next section to pull data from the feed instead
                                console.log("error");
                                console.log(err_2);
                                reject("ErrGetMeganavDataLocalStorage");
                                return [3 /*break*/, 4];
                            case 4:
                                if (!!jsonData) return [3 /*break*/, 9];
                                sharePointService = new SharePointService({
                                    useLocalStorage: true,
                                    localStorageTimeout: 240,
                                    enableLog: false
                                });
                                _a.label = 5;
                            case 5:
                                _a.trys.push([5, 7, , 8]);
                                spContext = window["_spPageContextInfo"];
                                return [4 /*yield*/, sharePointService.get(spContext.siteAbsoluteUrl + '/Style%20Library/custom-branding/nav/' + this.state.currentLang + '.config', false)];
                            case 6:
                                spResponse = _a.sent();
                                // console.log("JSON: response");
                                // console.log(spResponse);
                                // console.log(adminObj);
                                // console.log("push adminObj to localStorage");
                                localStorageKeyValue.keyValue = spResponse;
                                localStorageService.set(localStorageKeyValue);
                                // resolve(spResponse)
                                // return adminObj;
                                resolve(localStorageKeyValue.keyValue);
                                return [3 /*break*/, 8];
                            case 7:
                                err_3 = _a.sent();
                                console.log("an error occurred attempting to make a SP request");
                                console.log(err_3);
                                reject("ErrGetMeganavDataSPRequest");
                                return [3 /*break*/, 8];
                            case 8: return [3 /*break*/, 10];
                            case 9:
                                // we should never get here because jsonData should have been resolved on top
                                resolve(jsonData);
                                _a.label = 10;
                            case 10: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, p];
            });
        });
    };
    return Meganav;
}(React.Component));
export { Meganav };
